import { render, staticRenderFns } from "./drawing.vue?vue&type=template&id=02bede22&scoped=true&"
import script from "./drawing.vue?vue&type=script&lang=js&"
export * from "./drawing.vue?vue&type=script&lang=js&"
import style0 from "./drawing.vue?vue&type=style&index=0&id=02bede22&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bede22",
  null
  
)

export default component.exports